import { useMemo } from 'react';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { usePoliceChartsDataContext } from './hooks/usePoliceChartsDataContext';

const monthNames = [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Maio',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez'
];

const getMonthLabel = (mes) => {
    const monthIndex = parseInt(mes) - 1;
    const monthName = monthNames[monthIndex] || mes;
    return `${monthName}`;
};

export const BySituationMonth = () => {
    const { chartData } = usePoliceChartsDataContext();

    const { series, categories } = useMemo(() => {
        let monthData = chartData?.bySituationMonth || [];
        
        if (!monthData.length) {
            return { series: [], categories: [] };
        }

        // Sort data chronologically by year and month
        monthData = [...monthData].sort((a, b) => {
            const yearDiff = parseInt(a.ano_estatistica) - parseInt(b.ano_estatistica);
            if (yearDiff !== 0) return yearDiff;
            return parseInt(a.mes_estatistica) - parseInt(b.mes_estatistica);
        });

        // Limit to 12 consecutive months (last 12)
        monthData = monthData.slice(-12);

        // Get all unique corporations
        const situationSet = new Set();
        monthData.forEach(period => {
            period.situacoes?.forEach(situation => {
                situationSet.add(situation.situacao);
            });
        });

        // Create series for each corporation
        const corporationSeries = Array.from(situationSet).map(situationName => {
            const data = monthData.map(period => {
                const corporationData = period.situacoes?.find(b => b.situacao === situationName);
                return corporationData?.total || 0;
            });
            return {
                name: situationName,
                data: data
            };
        });

        // Get month/year as categories
        const monthCategories = monthData.map(item => 
            getMonthLabel(item.mes_estatistica)
        );

        return {
            series: corporationSeries,
            categories: monthCategories
        };
    }, [chartData?.bySituationMonth]);


    return (
        <SimpleBars
            title="Por Situação (Mensal)"
            horizontal={true}
            subtitles={categories}
            series={series}
            height={420}
            showDataLabels={true}
            stacked
        />
    );
};
